import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";

const ThemeSelector = ({
  value = "dark",
  onChange = () => {},
  label = "",
  inputName = "",
  boxSmall = false,
  isStorefront = false,
  margin = true,
  extraMargin = false,
  selectedBorder = false,
  noTitle = false,
}) => {
  const isDark = value === "dark";
  const isLight = value === "light";

  return (
    <div
      className="theme-selector"
      style={
        boxSmall
          ? {
              marginRight: 0,
            }
          : {}
      }
    >
      {!noTitle ? <span className="label">{label}</span> : null}
      <div className="boxes">
        <input name={inputName} value={value} hidden />
        <div
          className={`box${isDark ? " active" : ""}${
            extraMargin ? " extra-margin" : margin ? " margin" : ""
          }${selectedBorder ? " border" : ""}`}
          onClick={() => {
            onChange(inputName, "dark");
          }}
          style={
            boxSmall
              ? {
                  width: 102,
                }
              : {}
          }
        >
          <img
            alt="dark"
            src={`/img/new-icons/love-dark-${
              isStorefront ? "storefront" : "mobile"
            }.svg`}
            className="image-placeholder"
          />
          <div aria-current={value === "dark" ? true : undefined}>
            <SvgIcon
              src={`/img/new-icons/dark-theme-${
                value === "dark" ? "enabled" : "disabled"
              }.svg`}
              noFilterOnLight={value === "dark"}
            />
            <span>Dark</span>
          </div>
        </div>
        <div
          className={`box${isLight ? " active" : ""}${
            selectedBorder ? " border" : ""
          }`}
          onClick={() => {
            onChange(inputName, "light");
          }}
          style={
            boxSmall
              ? {
                  width: 102,
                }
              : {}
          }
        >
          <img
            alt="light"
            src={`/img/new-icons/love-light-${
              isStorefront ? "storefront" : "mobile"
            }.svg`}
            className="image-placeholder"
          />
          <div aria-current={value === "light" ? true : undefined}>
            <SvgIcon
              src={`/img/new-icons/light-theme-${
                value === "light" ? "enabled" : "disabled"
              }.svg`}
              noFilterOnLight={value === "light"}
            />
            <span>Light</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeSelector;
